import { z } from 'zod';
import { minimizedProfessionSchema } from './IMinimizedProfession';
import { SequenceTypeEnum } from './SequenceType.enum';
import { externalRefSchema } from './IExternalRef';
import { IProfession } from './IProfession';

// Schemas (source of truth) — pure validation, no transforms
export const sequenceItemSharedSchema = z.object({
	_id: z.string(),
	projectId: z.string(),
	sequenceId: z.string(),
	sequenceType: z.enum(SequenceTypeEnum),
	linkedMilestoneId: z.string().optional(),
	description: z.string(),
	orderIndex: z.number(),
	profession: minimizedProfessionSchema,
	isStarred: z.boolean().optional(),
	hasPartialAreas: z.boolean().optional(),
	/**
	 * Present only on items owned by an external system (`sequenceType: external`).
	 * Absent on every Trusstor-planned item, which is what keeps the unique index
	 * partial rather than colliding every row on a null triple.
	 */
	externalRef: externalRefSchema.optional(),
});

// Types (derived from schemas)
export type ISequenceItemShared<
	T extends z.infer<typeof minimizedProfessionSchema> = z.infer<typeof minimizedProfessionSchema>,
> = Omit<z.infer<typeof sequenceItemSharedSchema>, 'profession'> & { profession: T };
